<template>
  <div
    class="d-flex flex-wrap align-center ga-1 px-4 py-2 text-body-small"
    data-test-id="deepa-chat-context"
  >
    <span class="text-medium-emphasis me-1">
      {{ t('deepa_chat.context_label') }}
    </span>
    <v-chip
      v-for="node in visibleNodes"
      :key="node.nodeId"
      class="deepa-chat-context-chip"
      label
      size="small"
      :to="getContextNodeRoute(node)"
      variant="tonal"
    >
      <template #prepend>
        <NodeIcon
          class="me-1 flex-shrink-0"
          height="14"
          :mime-type="node.mimeType"
          :name="node.name"
          :type="node.type"
          width="14"
        />
      </template>
      <span class="text-truncate">{{ getContextNodeName(node) }}</span>
    </v-chip>
    <v-btn
      v-if="hiddenNodesCount > 0"
      class="text-none px-1"
      color="primary"
      density="compact"
      size="small"
      variant="text"
      @click="showDialog = true"
    >
      {{ t('deepa_chat.context_others', hiddenNodesCount) }}
    </v-btn>

    <DeepAChatContextDialog v-model="showDialog" :nodes />
  </div>
</template>

<script lang="ts" setup>
import DeepAChatContextDialog from '@/pocs/chat/components/DeepAChatContextDialog.vue'
import {
  getContextNodeRoute,
  useDeepAContextNodeName,
} from '@/pocs/chat/composables/context-node'
import NodeIcon from '@/components/node/NodeIcon.vue'
import type { DeepAChatContextNode } from '@/pocs/chat/types'

const MAX_VISIBLE_NODES = 2

const props = defineProps({
  nodes: {
    type: Array as PropType<DeepAChatContextNode[]>,
    default: () => [],
  },
})

const { t } = useI18n()
const getContextNodeName = useDeepAContextNodeName()

const showDialog = ref(false)

const visibleNodes = computed(() => props.nodes.slice(0, MAX_VISIBLE_NODES))

const hiddenNodesCount = computed(() =>
  Math.max(props.nodes.length - MAX_VISIBLE_NODES, 0),
)
</script>

<style lang="scss" scoped>
.deepa-chat-context-chip {
  max-width: 150px;
}
</style>
